import { useMemo } from 'react';
import { generateQrMatrix } from '../lib/qr.js';

/**
 * Renders a QR code for `value` entirely client-side (no image request to a
 * third party — the enrolment secret never leaves the browser). Always drawn
 * dark-on-white regardless of theme, with a quiet zone, so scanners work.
 */
export function QrCode({ value, size = 208 }: { value: string; size?: number }) {
  const { path, dim } = useMemo(() => {
    const matrix = generateQrMatrix(value);
    const n = matrix.length;
    const quiet = 4;
    let d = '';
    for (let y = 0; y < n; y += 1) {
      for (let x = 0; x < n; x += 1) {
        if (matrix[y]![x]) d += `M${x + quiet},${y + quiet}h1v1h-1z`;
      }
    }
    return { path: d, dim: n + quiet * 2 };
  }, [value]);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${dim} ${dim}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label="Two-factor enrolment QR code"
      className="rounded-lg ring-1 ring-slate-200 dark:ring-slate-700"
    >
      <rect width={dim} height={dim} fill="#ffffff" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
